import UserController from '@user/controllers/UserController'

// create single user controller intance
export default UserController()
